import * as React from 'react';
import { useSelector } from 'react-redux';
import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';
import { trackOpenContacts, trackShowPhone } from '../../actions/analytics';
import { CallButtonContainer } from '../CallButton';
import { getGaLabel } from '../../selectors/analytics';

export interface ICallToActionContainerProps {
  analyticOnOpenActionName?: string;
  dynamicCalltrackingPlaceType: string;
  onlyBuilderPhone?: boolean;
  fullWidth?: boolean;
  secondary?: boolean;
  XXL?: boolean;
  onPhoneShow?: () => void;
}

export const CallToActionContainer: React.FC<ICallToActionContainerProps> = ({
  analyticOnOpenActionName,
  dynamicCalltrackingPlaceType,
  onlyBuilderPhone,
  fullWidth,
  secondary,
  XXL,
  onPhoneShow,
}) => {
  const gaLabel = useSelector(getGaLabel);

  const handleOpenContacts = React.useCallback(() => {
    trackOpenContacts(gaLabel);
  }, [gaLabel]);

  const handleShowPhone = React.useCallback(() => {
    trackShowPhone(gaLabel, analyticOnOpenActionName);
    onPhoneShow?.();
  }, [analyticOnOpenActionName, gaLabel, onPhoneShow]);

  return (
    <CallButtonContainer
      openContactsStyles={{ size: XXL ? 'M' : 'XS', theme: secondary ? 'fill_secondary' : 'fill_primary', fullWidth }}
      showPhoneStyles={{
        size: XXL ? 'M' : 'XS',
        theme: secondary ? 'fill_secondary' : 'fill_primary',
        fullWidth,
        beforeIcon: <IconCommunicationPhone16 color={secondary ? 'icon-main-default' : 'icon-inverted-default'} />,
      }}
      onOpenContactsClick={handleOpenContacts}
      onlyBuilderPhone={onlyBuilderPhone}
      onShowPhoneClick={handleShowPhone}
      placeType={dynamicCalltrackingPlaceType}
    />
  );
};
